const AboutMe = () => {
    return (
        <div>About me</div>
    )
}

export default AboutMe;